import axios from 'axios'
import * as util from '@/assets/js/util'

// export const baseUrl = 'http://192.168.1.61:8080'
// export const shareUrl = 'https://share.xyzy.online'

// export const baseUrl = 'https://member.xyzy.online'
export const shareUrl = process.env.NODE_ENV !== 'development' ? 'https://share.xyzy.online' : 'http://192.168.31.241:8080'

export const baseUrl = process.env.NODE_ENV !== 'development' ? 'http://pc.rhslndx.cn' : 'http://pc.rhslndx.cn'

// export const baseUrl = 'http://192.168.31.241:8080'

export function get (url, data) {
  // url = 'http://120.78.145.189:9000' + url
  return axios.get(url, data)
}

export async function post (url, data, option) {
  const form = []
  addItemsToForm(form, [], data)
  url = baseUrl + url + '?t=' + util.getNow()
  return axios.post(url, form.join('&'), option)
}

export async function poemPost (url, option) {
  return axios({
    method: 'post',
    url,
    data: {
      option
    },
    transformRequest: [
      function (data) {
        let ret = ''
        for (let it in data) {
          ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
        }
        ret = ret.substring(0, ret.lastIndexOf('&'))
        return ret
      }
    ],
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}

export async function uploadPost (url, data, headers) {
  url = baseUrl + url + '?t=' + util.getNow()
  return axios.post(url, data, headers)
}

export function params (data) {
  let url = ''
  for (var k in data) {
    let value = data[k] !== undefined ? data[k] : ''
    url += `&${k}=${encodeURIComponent(value)}`
  }
  return url ? url.substring(1) : ''
}

function addItemsToForm (form, names, obj) {
  if (obj === undefined || obj === '' || obj === null) return addItemToForm(form, names, '')

  if (
    typeof obj === 'string' ||
    typeof obj === 'number' ||
    obj === true ||
    obj === false
  ) {
    return addItemToForm(form, names, obj)
  }

  if (obj instanceof Date) return addItemToForm(form, names, obj.toJSON())

  // array or otherwise array-like
  if (obj instanceof Array) {
    return obj.forEach((v, i) => {
      names.push(`[${i}]`)
      addItemsToForm(form, names, v)
      names.pop()
    })
  }

  if (typeof obj === 'object') {
    return Object.keys(obj).forEach((k) => {
      const newK = k.replace(/_\$search[^\\.]*/ig, '')
      names.push(newK)
      addItemsToForm(form, names, obj[k])
      names.pop()
    })
  }
}

function addItemToForm (form, names, value) {
  const name = encodeURIComponent(names.join('.').replace(/\.\[/g, '['))
  const newValue = encodeURIComponent(value.toString())
  form.push(`${name}=${newValue}`)
}



// WEBPACK FOOTER //
// ./src/assets/js/json.js